import {
	operations_browser_api_prefix,
	operations_api2_prefix,
	storefront_api2_prefix,
} from 'shared/var'
import fetchy from 'shared/fetchy'
import type { FetchyOptions } from 'shared/fetchy'

export const api_fetch = fetchy(operations_browser_api_prefix)
export const api2_fetch = fetchy(operations_api2_prefix)
export const uber_fetch = async(path: string, options: FetchyOptions = {}) => api2_fetch(path, {
	...options,
	fancily_serialize_body: true,
	expect_fancily_serialized_response: true,
})
export const storefront_api2_fetch = fetchy(storefront_api2_prefix)
export const storefront_uber_fetch = async(path: string, options: FetchyOptions = {}) => storefront_api2_fetch(path, {
	...options,
	fancily_serialize_body: true,
	expect_fancily_serialized_response: true,
})
